<template>
    <div>
        <div v-if="selectedContentUnit" class="fullview-close-button" @click="popHistory">ESC {{$t('message.close')}}</div>
        <section class="box-typical box-typical-full-height-with-header album">
            <header class="box-typical-header box-typical-header-bordered">
                <div class="tbl-row">
                    <div class="tbl-cell tbl-cell-title">
                        <h3>
                            {{meta.title}}
                            <span>{{album.content_units.length}} {{$t('message.photos')}}</span>
                            <button type="button" class="modal-close" @click="onCloseButtonClicked">
        						<i class="font-icon-close-2"></i>
        					</button>
                        </h3>
                    </div>
                </div>
            </header>
            <div class="box-typical-body">
                <div class="album-container">
                    <div v-for="contentUnit in album.content_units"
                        class="album-item"
                        :key="contentUnit.id"
                        :style="contentUnit._frontend ? contentUnit._frontend.style : {}">
                        <div class="album-item-image" @click="setSelectedContentUnit(contentUnit)"
                            :style="{backgroundImage: (contentUnit.thumbnail_file_name || contentUnit.file_name) ? ('url(' + context.storageEndpoint + (contentUnit.thumbnail_file_name || contentUnit.file_name) + ')') : ''}">
                        </div>
                        <div v-if="contentUnit.text" class="album-item-text">{{contentUnit.text}}</div>
                    </div>
                </div>
                <div v-if="selectedContentUnit" class="fullview-container" @mouseenter="() => {this.showFullViewControls = true}" @mouseleave="() => {this.showFullViewControls = false }">
                    <div class="fullview-image" :style="{
                        backgroundImage: ('url(' + context.storageEndpoint + selectedContentUnit.file_name + ')'),
                    }"></div>
                    <transition name="fade">
                        <div v-if="this.showFullViewControls" class="fullview-text">{{selectedContentUnit.text}}</div>
                    </transition>
                    <transition name="fade">
                        <div v-if="this.showFullViewControls && this.canGoBackward()" class="fullview-control-button fullview-backward-button" @click="this.backward">
                            <img class="backward-icon" src="/img/backward.png" />
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-if="this.showFullViewControls && this.canGoForward()" class="fullview-control-button fullview-forward-button" @click="this.forward">
                            <img class="forward-icon" src="/img/forward.png" />
                        </div>
                    </transition>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { EventViewPortfolioAlbumImage } from '../../bu/models/GA4';
    export default {
        props: [
            'context', 'album', 'editing', 'persistContentUnit', 'providerInformationBlockId',
            'close',
            'updateAlbumTitle', 'updateAlbumContentUnits', 'updateAlbumCover', 'addAlbumContentUnits', 'deleteAlbumContentUnit'
        ],

        data: function() {
            const contentUnitsMap = Vue.dingMapWithGivenKey(this.album.content_units, 'id');
            const isATouchingDevice = ('ontouchstart' in window);
            return {
                meta: this.album.meta,
                contentUnitsMap,
                status: {
                    saving: false,
                    editing: this.editing,
                },
                selectedContentUnit: null,
                showFullViewControls: isATouchingDevice
            };
        },

        watch: {
            meta: {
                deep: true,
                handler: function(newMeta, oldMeta) {
                    if (this.meta.cover_content_unit_id) {
                        this.album._frontend.cover_content_unit = this.contentUnitsMap[this.meta.cover_content_unit_id];
                    }
                }
            },
            album: {
                deep: true,
                handler: function(newAlbum, oldAlbum) {
                    this.contentUnitsMap = Vue.dingMapWithGivenKey(this.album.content_units, 'id');

                    if (this.meta.cover_content_unit_id) {
                        this.album._frontend.cover_content_unit = this.contentUnitsMap[this.meta.cover_content_unit_id];
                    }
                }
            },
            selectedContentUnit(newValue, oldValue) {
                this.updateHistoryStack();
            }
        },

        mounted() {
            window.addEventListener('resize', this.handleResize);
            window.addEventListener('keyup', this.handleKeyup);
            window.addEventListener('popstate', this.handlePopState)
            $('html, body').css('overflow', 'hidden');
            const height = (window.innerHeight) + 'px';
            $('.album').css('height', height);

            this.resizeGrid();

            window.history.pushState({}, null, '/i/' + this.providerInformationBlockId + '/a/' + this.album.meta.id);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('keyup', this.handleKeyup);
            window.removeEventListener('popstate', this.handlePopState);
            $('html, body').css('overflow', 'auto');

            if (window.location.pathname.match(/\/i\/.*\/a\/.*/)) {
                window.history.back();
            }
        },

        methods: {
            popHistory() {
                window.history.back()
            },
            handlePopState() {
                if (this.selectedContentUnit) {
                    this.selectedContentUnit = null;
                } else if (window.location.pathname === '/') {
                    this.close();
                }
            },
            updateHistoryStack() {
                if (this.selectedContentUnit) {
                    window.history.pushState({}, null, '/i/' + this.providerInformationBlockId + '/a/' + this.album.meta.id + '/p/' + this.selectedContentUnit.id);;
                }
            },

            handleResize(event) {
                this.resizeGrid();
            },

            handleKeyup(event) {
                switch (event.keyCode) {
                    case 27:
                        if (this.selectedContentUnit) {
                            this.setSelectedContentUnit(null);
                        } else {
                            this.close();
                        }
                        break;
                    case 37:
                        if (this.canGoBackward()) {
                            this.backward();
                        }
                        break;
                    case 39:
                        if (this.canGoForward()) {
                            this.forward();
                        }
                        break;
                    default:
                        break;
                }
            },

            resizeGrid() {
                const height = (window.innerHeight) + 'px';
                $('.album').css('height', height);

                const spacing = 2;
                const targetHeight = 240;
                const containerWidth = parseInt($('.album-container').css('width'));
                const targetRatio = containerWidth / targetHeight;

                var rows = [];
                var currentRow = {
                    units: [],
                    totalWidth: 0,
                    accumRatio: 0
                };
                for (var index in this.album.content_units) {
                    const unit = this.contentUnitsMap[this.album.content_units[index].id];
                    currentRow.units.push(unit);

                    currentRow.accumRatio += parseInt(unit.image_width) / parseInt(unit.image_height);
                    currentRow.totalWidth += parseInt(unit.image_width);
                    if (targetHeight > containerWidth / currentRow.accumRatio) {
                        rows.push(currentRow);
                        currentRow = {
                            units: [],
                            totalWidth: 0,
                            accumRatio: 0
                        };
                    }
                }
                if (currentRow.units.length > 0) {
                    currentRow.incomplete = true;
                    rows.push(currentRow);
                }

                var albumContainerHeight = 0;
                for (var i in rows) {
                    const row = rows[i];

                    var displayHeight = 0;
                    if (row.incomplete) {
                        displayHeight = targetHeight;
                    } else {
                        displayHeight = containerWidth / row.accumRatio;
                    }

                    for (var j in row.units) {
                        const unit = row.units[j];
                        const w = parseInt(unit.image_width);
                        const h = parseInt(unit.image_height);
                        var displayWidth = Math.floor(displayWidth = displayHeight * (w / h));
                        const frontend = {
                            style: {
                                width: displayWidth + 'px',
                                height: displayHeight + 'px'
                            }
                        };
                        this.$set(unit, '_frontend', frontend);
                    }
                    albumContainerHeight += displayHeight;
                }
                if (rows.length > 0) {
                    // This is the height for box-typical header
                    // Due to the container of this album-container height is 100%
                    albumContainerHeight += 56;
                }
                $('.album-container').css('height', albumContainerHeight + 'px');
            },

            setSelectedContentUnit(contentUnit) {
                this.selectedContentUnit = contentUnit;
                this.trackViewPortfolioAlbumImage(contentUnit);
            },

            openContentUnitId(id) {
                this.selectedContentUnit = this.contentUnitsMap[id];
            },

            // ++
            canGoForward() {
                const ids = this.album.content_units.map((unit) => unit.id);
                return ids.indexOf(this.selectedContentUnit.id) < ids.length - 1;
            },

            // --
            canGoBackward() {
                const ids = this.album.content_units.map((unit) => unit.id);
                return ids.indexOf(this.selectedContentUnit.id) > 0;
            },

            forward() {
                const ids = this.album.content_units.map((unit) => unit.id);
                this.setSelectedContentUnit(this.album.content_units[ids.indexOf(this.selectedContentUnit.id) + 1]);
            },

            backward() {
                const ids = this.album.content_units.map((unit) => unit.id);
                this.setSelectedContentUnit(this.album.content_units[ids.indexOf(this.selectedContentUnit.id) - 1]);
            },

            onCloseButtonClicked() {
                this.close(this.meta.id);
            },

            trackViewPortfolioAlbumImage(img) {
                window.tracker.track(() => new EventViewPortfolioAlbumImage(this.meta.id, img));
            }
        }
    }
</script>

<style scoped lang="scss">
.box-typical {
        border-radius: 0px;
        margin: 0;
    }

    .box-typical-body {
        height: 100%;
        overflow: auto;
    }

    .fullview-container {
        position:absolute;
        top:0px;
        left:0px;
        right:0px;
        bottom: 0px;
        padding: 8px;
        background: black;
    }

    .fullview-control-button {
        width: 25%;
        top: 0;
        bottom: 0;
        position: absolute;
        cursor: pointer;
    }

    .fullview-backward-button {
        left: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }

    .fullview-forward-button {
        right: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }

    .fullview-image {
        position: absolute;
        left: 0px;
        right: 0px;
        bottom: 0px;
        top: 0px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    .fullview-close-button {
        position: fixed;
        top: 1px;
        right: 1px;
        background-color: #333;
        color: #F0F0F0;
        font-size: 16px;
        padding: 4px 8px;
        cursor: pointer;
        z-index: 1000;
    }

    .fullview-close-button:hover {
        background-color: #444;
    }

    .fullview-text {
        color: white;
        font-size: 18px;
        padding: 1em;
        background: linear-gradient(rgba(0, 0, 0, .5), rgba(0,0,0,0));
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }

    .album-container {
        line-height: 0;

        .album-item-text {
            line-height: 1.5;
        }
    }

    .album-title {
        font-size: 20px;
    }

    .album {
        position: fixed;
        top: 0px;
        right: 0px;
        left: 0px;
        bottom: 0;
        z-index: 100;
        overflow: hidden;
        border: none;
    }

    .album-text-wrapper {
        display: block;;
        border-radius: 2px;
        max-width: 90%;
        padding: 1em;
        min-height: 48px;
        background: #F0F0F0;
    }

    .album-item {
        display: inline-block;
        position: relative;
    }

    .album-item-image {
        background-size: cover;
        background-position: center;
        position: absolute;
        top: 2px;
        left: 2px;
        right: 2px;
        bottom: 2px;
    }

    .album-item-text {
        position: absolute;
        left: 2px;
        right: 2px;
        bottom: 2px;
        background: linear-gradient(0deg, rgba(0,0,0,0.6), transparent);
        color: white;
        font-size: 12px;
        padding: 1em;
    }

    .thumb-view {
        width: 100%;
        overflow-y: scroll;
        overflow-x: scroll;
        padding: 0 1em;
    }

    .thumb-item {
        height: 32px;
        width: auto;
        display: inline-block;
        margin: 2px 2px;
        cursor: grab;
    }

    .thumb-item img {
        height: 40px;
        width: auto;
    }

    .btn-add-image {
        margin-bottom: 0px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
